export default __webpack_public_path__ + "75d8bc8e582446cb68f63b7f93d486ea.svg";